import React, {lazy, Suspense, useEffect, useRef, useState} from 'react';
import './styles/App.css'
import mediumRes from "./assets/mediumRes.jpg";
import lowRes from "./assets/lowRes.jpg";
import {Block} from "./components/block";
import {IoMenu} from "react-icons/io5";
import {Sidebar} from "./components/sidebar";
import {IoIosArrowBack} from "react-icons/io";
import {Routes, Route, useLocation, Link} from "react-router-dom";
import {projectSubpages} from "./data/projects";
import {parentPath} from "./paths";
import {lite} from "./lite";

// Full screen, outside the site's frame, and loaded on its own so three.js stays out of the main bundle.
const BlueprintEditor = lazy(() => import("./components/earthPlace/editor/EditorPage"));


const VALID_PAGES = ["about", "projects", "photos", "friends"] as const;
type Page = typeof VALID_PAGES[number];

function pageFromPath(pathname: string): Page {
    const slug = pathname.split("/")[1] || "about";
    if (VALID_PAGES.includes(slug as Page)) return slug as Page;
    return "about";
}

export function App() {

    const [display, setDisplay] = useState<boolean>(false);
    const [background, setBackground] = useState(lowRes);

    const location = useLocation();
    const active = pageFromPath(location.pathname);
    const projectSub = location.pathname.replace(/^\/projects\/?/, "").replace(/\/+$/, "");
    // any address that isn't a page gets the 404 page (Block with active="notfound")
    const known = /^\/(projects|photos|friends)?\/?$/.test(location.pathname)
        || (location.pathname.startsWith("/projects/") && projectSubpages.includes(projectSub));

    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (lite) return; // keep the small background on limited data
        const midRes = new Image();
        midRes.src = mediumRes;
        midRes.onload = () => {
            setBackground(mediumRes);
        };
    }, []);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0 });
        }
    }, [location.pathname]);

    if (/^\/projects\/earthplace\/editor\/?$/.test(location.pathname))
        return <Suspense fallback={null}><BlueprintEditor/></Suspense>;

    const showMenu = () => {
        setDisplay(!display);
    }

    const hideMenu = () => {
        setDisplay(false);
    }

    return (
        <div className="App">
            <img className={"background"} src={background} alt=""/>
            <div className={"vignette"} onClick={hideMenu} ref={scrollRef}>
                <Routes>
                    <Route path="/" element={<Block active="about"/>}/>
                    <Route path="/projects" element={<Block active="projects"/>}/>
                    <Route path="/projects/*" element={projectSubpages.includes(projectSub)
                        ? <Block active="projects" sub={projectSub}/>
                        : <Block active="notfound"/>}/>
                    <Route path="/photos" element={<Block active="photos"/>}/>
                    <Route path="/friends" element={<Block active="friends"/>}/>
                    <Route path="*" element={<Block active="notfound"/>}/>
                </Routes>
            </div>
            <Sidebar hideMenu={hideMenu} id={display ? "open" : "closed"} current={known ? active : "notfound"}/>
            <button className="button mobileMenu" onClick={showMenu} aria-label="Menu" aria-expanded={display}><IoMenu/></button>
            <Link className={"button"} id={active === "about" && known ? "hide" : "backMobile"} to={known ? parentPath(location.pathname) : "/"} aria-label={known ? "Back" : "Home"}><IoIosArrowBack/></Link>
        </div>
    );
}
